import i18next from 'i18next';
import React, { useEffect } from 'react';

import { Dropdown } from '@commons/utils/styledLibraryComponents';
import { PeriodDatePicker } from '@commons/DatePickers/PeriodDatePicker';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

// Style
import { Container, PeriodDatePickerContainer } from './styledComponents';
import {
  LabelContainer,
  LabelRequiredCharacter,
} from '@commons/ExportModalWithStoresAndPeriod/styledComponents';

import { usePeriodDatePickerState } from '@hooks/usePeriodDatePickerState';

const ProductForecastTemplateModal = (props) => {
  const {
    // Handle stores
    filteredStores,
    selectedStores,
    setSelectedStores,
    // Handle categories
    categories,
    selectedCategories,
    setSelectedCategories,
    // Handle date period
    initialStartDate,
    initialEndDate,
    maxPastDate,
    maxFutureDate,
    setTemplatePeriod,
    // Miscellaneous
    defaultTimezone,
    clientStoreName,
  } = props;

  const periodPickerState = usePeriodDatePickerState(
    initialStartDate,
    initialEndDate,
    defaultTimezone,
  );

  useEffect(() => {
    if (!periodPickerState.startDate || !periodPickerState.endDate) {
      return;
    }

    setTemplatePeriod({
      startDate: periodPickerState.startDate,
      endDate: periodPickerState.endDate,
    });
  }, [periodPickerState.startDate, periodPickerState.endDate]);

  return (
    <Container>
      <Dropdown
        customStyle={{
          position: 'inherit',
          height: '68px',
        }} // for the list to appear over the modal (instead of inside)
        iconSrc="/images/inpulse/pin-black-small.svg"
        isUniqueSelection={false}
        items={filteredStores}
        label={`${clientStoreName} :`}
        searchPlaceholder={i18next.t('GENERAL.SEARCH')}
        selectedItems={selectedStores}
        isRequired
        onSelectionChange={setSelectedStores}
      />
      <Dropdown
        customStyle={{
          position: 'inherit',
          height: '68px',
        }} // for the list to appear over the modal (instead of inside)
        iconSrc="/images/inpulse/group-black-small.svg"
        isUniqueSelection={false}
        items={categories}
        label={`${i18next.t('GENERAL.CATEGORIES')} :`}
        searchPlaceholder={i18next.t('GENERAL.SEARCH')}
        selectedItems={selectedCategories}
        isRequired
        onSelectionChange={setSelectedCategories}
      />
      <PeriodDatePickerContainer>
        <LabelContainer>
          <LabelRequiredCharacter>*</LabelRequiredCharacter>
          <Text
            color={ENUM_COLORS.DARKEST}
            font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {i18next.t('FORECAST.SALES_PLANNING.PRODUCT_FORECAST_TEMPLATE_MODAL_DATE_RANGE')} :
          </Text>
        </LabelContainer>
        <PeriodDatePicker
          customStyle={{ position: 'absolute' }} // for the list to appear over the modal (instead of inside)
          disabled={false}
          endDate={periodPickerState.endDate}
          focusedDateInput={periodPickerState.focusedDateInput}
          maxFutureDate={maxFutureDate}
          maxPastDate={maxPastDate}
          setFocusedDateInput={periodPickerState.setFocusedDateInput}
          startDate={periodPickerState.startDate}
          timezone={defaultTimezone}
          onDatesChange={periodPickerState.handleSelectedDates}
        />
      </PeriodDatePickerContainer>
    </Container>
  );
};

export default ProductForecastTemplateModal;
